document.addEventListener("DOMContentLoaded", function () {
  const tabWrappers = document.querySelectorAll("[id^='quote-tab-logos-']");

  tabWrappers.forEach((tabWrapper) => {
    const sectionId = tabWrapper.id.replace("quote-tab-logos-", ""); // Extract section ID
    const tabs = tabWrapper.querySelectorAll(".quote-logo-tab");
    const contents = document.querySelectorAll(`#quote-tab-content-${sectionId} .quote-tab-content`);

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        // Remove active class from all tabs and contents
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));

        // Add active class to the clicked tab and corresponding content
        tab.classList.add("active");
        contents[index].classList.add("active");
      });
    });
  });
});